import axios from 'axios'

/**
 * 取得通知清單、分頁資訊
 * @return {Promise} axios promise
 */
export function requestNotifications() {
  return axios.get('/api/v1/notifications')
}

/**
 * 已讀當前通知
 * @param  {Number}  notificationId - notification id
 * @return {Promise} axios promise
*/
export function requestReadNotification({ notificationId }) {
  return axios.patch(`/api/v1/notifications/${notificationId}/read`)
}

/**
 * 重置未讀通知數量
 * @return {Promise} axios promise
 */
export function requestResetUninspectedCount() {
  return axios.patch('/api/v1/notifications/reset_uninspected_count')
}
